
// import axios from '../../API/axios';
// import {
//     FETCH_WORKLEVEL_TYPE_REQUEST,
//     FETCH_WORKLEVEL_TYPE_SUCCESS,
//     FETCH_WORKLEVEL_TYPE_FAILURE,
//     SET_WORKLEVEL_COMPANY_TYPE,
// } from '../types';

// export const fetchWorkLevelTypeData = () => async (dispatch) => {
//     dispatch({ type: FETCH_WORKLEVEL_TYPE_REQUEST });
//     try {
//         const response = await axios.get('MasterDDL/GetWorkLevelTypesDDL');
//         console.log('WorkLevelTypeResponse:', response);

//         const workLevelOptions = response.data.responseData.map((val) => ({
//             value: val.id,
//             label: val.name,
//         }));

//         dispatch({
//             type: FETCH_WORKLEVEL_TYPE_SUCCESS,
//             payload: workLevelOptions,
//         });
//     } catch (error) {
//         dispatch({
//             type:  FETCH_WORKLEVEL_TYPE_FAILURE,
//             payload: error.message,
//         });
//     }
// };

// export const selectWorkLevel = (sizeId) => ({
//     type: SET_WORKLEVEL_COMPANY_TYPE,
//     payload: sizeId, 
// });

// actions.js

import axios from '../../API/axios';

import {
  FETCH_WORKLEVEL_TYPE_REQUEST,
  FETCH_WORKLEVEL_TYPE_SUCCESS,
  FETCH_WORKLEVEL_TYPE_FAILURE,
  SELECT_WORKLEVEL,
} from '../types'; 

// Fetch Work Level Types
export const fetchWorkLevelTypeData = () => async (dispatch) => {
  dispatch({ type: FETCH_WORKLEVEL_TYPE_REQUEST });
  
  try {
    const response = await axios.get('MasterDDL/GetWorkLevelTypesDDL');
    const workLevelOptions = response.data.responseData.map((val) => ({
      value: val.id,
      label: val.name,
  }));
    dispatch({
      type: FETCH_WORKLEVEL_TYPE_SUCCESS,
      payload: workLevelOptions,
    });
  } catch (error) {
    dispatch({
      type: FETCH_WORKLEVEL_TYPE_FAILURE,
      payload: error.message,
    });
  }
};

// Select Work Level
export const selectWorkLevel = (id) => ({
  type: SELECT_WORKLEVEL,
  payload: id,
});

